<template>
  <div
    id="audit-log"
    class="page page-data-management"
  >
    <div class="page-toolbar bg-white shadow-sm p-3 justify-content-between align-items-center">
      <h4 class="m-0">
        Audit Log
      </h4>
    </div>
    <div
      id="pageContent"
      class="page-content d-flex flex-column p-3"
    >
      <content-spinner :show="loading" />
      <div
        v-show="!loading"
        class="complex-table-view-wrapper"
      >
        <complex-table-view
          :small="true"
          :items="items"
          :is-audit="true"
          :fields="initialFields"
          :total-rows="totalRows"
          :modal-name="'audit-log'"
          :loading="auditLog.loading"
          @filter="filterData"
          @sort-changed="onSortChanged"
          @per-page-change="onPaginationChange"
          @current-page-change="onPaginationChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ComplexTableView from '../../../core/components/complex-table/components/ComplexTableView';
import ContentSpinner from '../../../core/components/ContentSpinner';
import filterMixin from '../../../core/mixins/filter.mixin';
import {createNamespacedHelpers} from 'vuex';

const {mapState, mapActions} = createNamespacedHelpers('systemInfo');
const {mapState: mapDataManagementState} = createNamespacedHelpers('dataManagement');
const {mapActions: mapActionsUser, mapState: mapStateUser} = createNamespacedHelpers('user');
export default {
  name: 'AuditLog',
  components: {ContentSpinner, ComplexTableView},
  mixins: [filterMixin],
  data() {
    return {
      filters: {},
      auditLogFields: [
        {key: 'apiLogId', label: 'API Log ID', dataTypeName: 'wholeNumber'},
        {key: 'logDate', label: 'Log Date', dataTypeName: 'dateTime'},
        {key: 'userGuid', label: 'User', dataTypeName: 'user'},
        {key: 'operationId', label: 'Operation ID', dataTypeName: 'text'},
        {key: 'moduleName', label: 'Module Name', dataTypeName: 'text'},
        {key: 'logLevel', label: 'Log Level', dataTypeName: 'text'},
        {key: 'message', label: 'Message', dataTypeName: 'text'},
      ],
      items: [],
      loading: false,
    };
  },
  computed: {
    ...mapState(['auditLog']),
    ...mapStateUser(['users']),
    totalRows() {
      return this.items.length ? this.items[0].totalRows : 0;
    },
    initialFields() {
      return this.auditLogFields.map(field => {
        if (field.dataTypeName === 'user') {
          field.options = this.users.data.map(user => ({value: user.id, text: user.displayName}));
        }
        return field;
      });
    },
  },
  methods: {
    ...mapActions(['getAuditLogData', 'changePagination', 'changeFilter']),
    ...mapActionsUser(['getUsersAndGroups']),
    async filterData(query) {
      this.filters = query.filter || query;
      await this.changeFilter(this.filters);
      await this.getData();
    },
    onSortChanged(e) {
      this.items.sort(function (a, b) {
        if (a[e.sortBy] < b[e.sortBy]) {
          return e.sortDesc ? 1 : -1;
        }
        if (a[e.sortBy] > b[e.sortBy]) {
          return e.sortDesc ? -1 : 1;
        }
        return 0;
      });
    },
    async onPaginationChange(params) {
      await this.changePagination(params);
      await this.getData();
    },
    getFiltersFromUrl() {
      if (this.$route.query.filters) {
        this.filters = JSON.parse(decodeURIComponent(this.$route.query.filters));
      }
    },
    async getData() {
      const pageNumber = this.auditLog.pagination.currentPage;
      const offset = this.auditLog.pagination.perPage;

      const fieldNames = Object.keys(this.auditLog.filter);
      const filter = {};
      fieldNames.forEach(field => {
        if (this.auditLog.filter[field]) {
          if (field === 'userGuid' && this.auditLog.filter[field].selectItems.length) {
            filter[field] = this.auditLog.filter[field].selectItems[0].value;
          } else {
            filter[field] = this.auditLog.filter[field].text;
          }
        }
      });

      const params = {
        PageNumber: pageNumber,
        Offset: offset,
        Filter: filter,
      };

      await this.getAuditLogData(params);
      this.items = JSON.parse(JSON.stringify(this.auditLog.data));
      if (this.items.length) {
        this.items = this.items.map(item => {
          const user = this.users.data.find(user => user.id === item.userGuid);
          if (user) {
            item.userGuid = user.displayName;
          }
          return item;
        });
      }
    },
  },
  async mounted() {
    this.loading = true;
    await this.getUsersAndGroups();

    this.getFiltersFromUrl();
    if (Object.keys(this.filters).length > 0) {
      await this.filterData(this.filters);
    } else {
      await this.getData();
    }

    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>

.complex-table-view-wrapper {
  flex: 1;
  overflow: hidden;
}
</style>